var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ContentWrapper",
    [
      _c("div", { staticClass: "content-heading" }, [
        _c("div", [_vm._v("개체정보")])
      ]),
      _c("div", { staticClass: "card card-default" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("form", { attrs: { "data-vv-scope": "edit" } }, [
            _c(
              "table",
              {
                staticClass: "table table-bordered",
                staticStyle: { "background-color": "#f7f7f7" }
              },
              [
                _c("colgroup", [
                  _c("col", {
                    staticClass: "bg-lightdark",
                    attrs: { width: "15%" }
                  }),
                  _c("col", { attrs: { width: "35%" } }),
                  _c("col", {
                    staticClass: "bg-lightdark",
                    attrs: { width: "15%" }
                  }),
                  _c("col", { attrs: { width: "35%" } })
                ]),
                _c("tr", [
                  _c("th", [_vm._v("파일시퀀스")]),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.row.fileSeq,
                          expression: "data.row.fileSeq"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''"
                        }
                      ],
                      class: {
                        "not-text form-control": true,
                        "is-invalid": _vm.errors.has("edit.fileSeq")
                      },
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "text",
                        placeholder: "fileSeq",
                        name: "fileSeq",
                        readonly: ""
                      },
                      domProps: { value: _vm.data.row.fileSeq },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.data.row, "fileSeq", $event.target.value)
                        }
                      }
                    }),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("edit.fileSeq"),
                            expression: "errors.has('edit.fileSeq')"
                          }
                        ],
                        staticClass: "invalid-feedback"
                      },
                      [_vm._v(_vm._s(_vm.errors.first("edit.fileSeq")))]
                    )
                  ]),
                  _c("th", [_vm._v("개체유형")]),
                  _c("td", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.getFileTypeName(_vm.data.row.fileTypeCd))
                      )
                    ])
                  ])
                ]),
                _c("tr", [
                  _c("th", [_vm._v("개체출처")]),
                  _c("td", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.getFileDivName(_vm.data.row.fileDivCd)))
                    ])
                  ]),
                  _c("th", [_vm._v("외부개체ID")]),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.row.extFileId,
                          expression: "data.row.extFileId"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''"
                        }
                      ],
                      class: {
                        "not-text form-control": true,
                        "is-invalid": _vm.errors.has("edit.extFileId")
                      },
                      staticStyle: { width: "100%" },
                      attrs: { type: "text", name: "extFileId", readonly: "" },
                      domProps: { value: _vm.data.row.extFileId },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.data.row,
                            "extFileId",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("edit.extFileId"),
                            expression: "errors.has('edit.extFileId')"
                          }
                        ],
                        staticClass: "invalid-feedback"
                      },
                      [_vm._v(_vm._s(_vm.errors.first("edit.extFileId")))]
                    )
                  ])
                ]),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.exterUrl && !_vm.contentsUrl,
                        expression: "!exterUrl && !contentsUrl"
                      }
                    ]
                  },
                  [
                    _c("th", [_vm._v("원본파일명")]),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.row.orgFileNm,
                            expression: "data.row.orgFileNm"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "",
                            expression: "''"
                          }
                        ],
                        class: {
                          "not-text form-control": true,
                          "is-invalid": _vm.errors.has("edit.orgFileNm")
                        },
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "text",
                          placeholder: "orgFileNm",
                          name: "orgFileNm",
                          readonly: ""
                        },
                        domProps: { value: _vm.data.row.orgFileNm },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.data.row,
                              "orgFileNm",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("edit.orgFileNm"),
                              expression: "errors.has('edit.orgFileNm')"
                            }
                          ],
                          staticClass: "invalid-feedback"
                        },
                        [_vm._v(_vm._s(_vm.errors.first("edit.orgFileNm")))]
                      )
                    ]),
                    _c("th", [_vm._v("파일크기")]),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "",
                            expression: "''"
                          }
                        ],
                        class: {
                          "not-text form-control": true,
                          "is-invalid": _vm.errors.has("edit.size")
                        },
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "text",
                          placeholder: "size",
                          name: "size",
                          readonly: ""
                        },
                        domProps: { value: _vm.orgFileSize }
                      }),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("edit.size"),
                              expression: "errors.has('edit.size')"
                            }
                          ],
                          staticClass: "invalid-feedback"
                        },
                        [_vm._v(_vm._s(_vm.errors.first("edit.size")))]
                      )
                    ])
                  ]
                ),
                _c("tr", [
                  _c("th", [_vm._v("등록자/등록일")]),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''"
                        }
                      ],
                      class: {
                        "not-text form-control": true,
                        "is-invalid": _vm.errors.has("edit.regId")
                      },
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "text",
                        placeholder: "regId",
                        name: "regId",
                        readonly: ""
                      },
                      domProps: {
                        value:
                          _vm.data.row.regId + "(" + _vm.data.row.regDt + ")"
                      }
                    }),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("edit.regId"),
                            expression: "errors.has('edit.regId')"
                          }
                        ],
                        staticClass: "invalid-feedback"
                      },
                      [_vm._v(_vm._s(_vm.errors.first("edit.regId")))]
                    )
                  ]),
                  _c("th", [_vm._v("수정자/수정일")]),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "",
                          expression: "''"
                        }
                      ],
                      class: {
                        "not-text form-control": true,
                        "is-invalid": _vm.errors.has("edit.regDt")
                      },
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "text",
                        placeholder: "regDt",
                        name: "regDt",
                        readonly: ""
                      },
                      domProps: {
                        value:
                          _vm.data.row.updId + "(" + _vm.data.row.updDt + ")"
                      }
                    }),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("edit.regDt"),
                            expression: "errors.has('edit.regDt')"
                          }
                        ],
                        staticClass: "invalid-feedback"
                      },
                      [_vm._v(_vm._s(_vm.errors.first("edit.regDt")))]
                    )
                  ])
                ])
              ]
            ),
            _c("table", { staticClass: "table table-bordered mt-4" }, [
              _c("colgroup", [
                _c("col", {
                  staticClass: "bg-lightdark",
                  attrs: { width: "15%" }
                }),
                _c("col", { attrs: { width: "35%" } }),
                _c("col", {
                  staticClass: "bg-lightdark",
                  attrs: { width: "15%" }
                }),
                _c("col", { attrs: { width: "35%" } })
              ]),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.exterUrl && !_vm.contentsUrl,
                      expression: "!exterUrl && !contentsUrl"
                    }
                  ]
                },
                [
                  _c("th", [_vm._v("원본파일")]),
                  _c("td", { attrs: { colspan: "4" } }, [
                    _c("div", { staticClass: "custom-file" }, [
                      _c("input", {
                        staticClass: "display-file",
                        attrs: { type: "file", id: "fileInfo" },
                        on: { change: _vm.insertFileName }
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "custom-file-label",
                          attrs: { for: "fileInfo" }
                        },
                        [_vm._v(_vm._s(_vm.fileName))]
                      ),
                      _c("div", { staticClass: "file-info" }, [
                        _c("span", [
                          _vm._v("원본 경로 : " + _vm._s(_vm.data.row.url))
                        ]),
                        _c(
                          "div",
                          { staticClass: "button-wrap" },
                          [
                            _c(
                              "b-btn",
                              {
                                staticClass: "btn mr-2",
                                on: {
                                  click: function($event) {
                                    return _vm.downloadAs(
                                      _vm.data.row.fileDivCd,
                                      _vm.data.row.url,
                                      _vm.data.row.orgFileNm
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-download mr-1" }),
                                _vm._v("다운로드")
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ]
              ),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.exterUrl && !_vm.contentsUrl,
                      expression: "!exterUrl && !contentsUrl"
                    }
                  ]
                },
                [
                  _c("th", [_vm._v("미리보기파일")]),
                  _c("td", { attrs: { colspan: "4" } }, [
                    _c("div", { staticClass: "custom-file" }, [
                      _c("div", { staticClass: "form-check mb-2" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.row.contentsViewFileUploadYn,
                              expression: "data.row.contentsViewFileUploadYn"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            "true-value": "Y",
                            "false-value": "N",
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(
                              _vm.data.row.contentsViewFileUploadYn
                            )
                              ? _vm._i(
                                  _vm.data.row.contentsViewFileUploadYn,
                                  null
                                ) > -1
                              : _vm._q(
                                  _vm.data.row.contentsViewFileUploadYn,
                                  "Y"
                                )
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.data.row.contentsViewFileUploadYn,
                                $$el = $event.target,
                                $$c = $$el.checked ? "Y" : "N"
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.data.row,
                                      "contentsViewFileUploadYn",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.data.row,
                                      "contentsViewFileUploadYn",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(
                                  _vm.data.row,
                                  "contentsViewFileUploadYn",
                                  $$c
                                )
                              }
                            }
                          }
                        }),
                        _c("label", { staticClass: "form-check-label" }, [
                          _vm._v(
                            "VIEW용 PDF 업로드(첨부파일이 PDF로 변환이 불가한 경우)"
                          )
                        ])
                      ]),
                      _c("input", {
                        staticClass: "display-file",
                        attrs: {
                          type: "file",
                          accept: ".pdf",
                          disabled:
                            _vm.data.row.contentsViewFileUploadYn == "N",
                          id: "previewFileInfo"
                        },
                        on: { change: _vm.insertPreviewFileName }
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "custom-file-label",
                          style: {
                            backgroundColor:
                              _vm.data.row.contentsViewFileUploadYn == "N"
                                ? "lightgray"
                                : ""
                          },
                          attrs: { for: "previewFileInfo" }
                        },
                        [_vm._v(_vm._s(_vm.previewFileName))]
                      ),
                      _c("div", { staticClass: "file-info" }, [
                        _c("span", [
                          _vm._v(
                            "미리보기 경로 : " +
                              _vm._s(_vm.data.row.contentsViewFilePath)
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "button-wrap" },
                          [
                            _c(
                              "b-btn",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.mediaFile,
                                    expression: "!mediaFile"
                                  }
                                ],
                                staticClass: "btn",
                                on: {
                                  click: function($event) {
                                    return _vm.goViewFileUrl(
                                      _vm.data.row.contentsViewFilePath
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-search mr-1" }),
                                _vm._v("미리보기")
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "file-info",
                          staticStyle: {
                            color: "red",
                            height: "20px",
                            "margin-top": "0"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "※미리보기파일을 등록하지 않을 경우 원본파일이 PDF로 자동변환됩니다."
                            )
                          ])
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.exterUrl || _vm.contentsUrl,
                      expression: "exterUrl || contentsUrl"
                    }
                  ]
                },
                [
                  _c("th", [_vm._v("링크경로")]),
                  _c(
                    "td",
                    { attrs: { colspan: "4" } },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.row.linkUrl,
                            expression: "data.row.linkUrl"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "",
                            expression: "''"
                          }
                        ],
                        class: {
                          "form-control": true,
                          "is-invalid": _vm.errors.has("edit.linkUrl")
                        },
                        attrs: {
                          type: "text",
                          placeholder: "linkUrl",
                          name: "linkUrl"
                        },
                        domProps: { value: _vm.data.row.linkUrl },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.data.row,
                              "linkUrl",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _c(
                        "b-btn",
                        {
                          staticClass: "btn",
                          on: {
                            click: function($event) {
                              return _vm.openTabPreview(_vm.data.row.linkUrl)
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-search mr-1" }),
                          _vm._v("링크열기")
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c("tr", [
                _c("th", [_c("span", [_vm._v("썸네일링크")])]),
                _c("td", { attrs: { colspan: "3" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.row.thumbnailPath,
                        expression: "data.row.thumbnailPath"
                      }
                    ],
                    class: { "form-control": true },
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "text",
                      name: "thumbnailPath",
                      placeholder: "Url..."
                    },
                    domProps: { value: _vm.data.row.thumbnailPath },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.data.row,
                          "thumbnailPath",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _c("tr", [
                _c("th", [_vm._v("노출개체명*")]),
                _c("td", { attrs: { colspan: "4" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.row.dispFileNm,
                        expression: "data.row.dispFileNm"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''"
                      }
                    ],
                    class: {
                      "form-control": true,
                      "is-invalid": _vm.errors.has("edit.dispFileNm")
                    },
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "text",
                      placeholder: "dispFileNm",
                      name: "dispFileNm"
                    },
                    domProps: { value: _vm.data.row.dispFileNm },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.data.row,
                          "dispFileNm",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("edit.dispFileNm"),
                          expression: "errors.has('edit.dispFileNm')"
                        }
                      ],
                      staticClass: "invalid-feedback"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("edit.dispFileNm")))]
                  )
                ])
              ]),
              _c("tr", [
                _c("th", [_vm._v("노출대상*")]),
                _c(
                  "td",
                  { attrs: { colspan: "4" } },
                  [
                    _c("b-input-group", [
                      _c("div", [
                        _c("div", { staticClass: "form-check mb-2" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.data.row.teacherUseYn,
                                expression: "data.row.teacherUseYn"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              "true-value": "Y",
                              "false-value": "N",
                              type: "checkbox"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.data.row.teacherUseYn)
                                ? _vm._i(_vm.data.row.teacherUseYn, null) > -1
                                : _vm._q(_vm.data.row.teacherUseYn, "Y")
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.data.row.teacherUseYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : "N"
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.data.row,
                                        "teacherUseYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.data.row,
                                        "teacherUseYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.data.row, "teacherUseYn", $$c)
                                }
                              }
                            }
                          }),
                          _c("label", { staticClass: "form-check-label" }, [
                            _vm._v("교사사용")
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.data.row.tutorUseYn,
                                expression: "data.row.tutorUseYn"
                              }
                            ],
                            staticClass: "form-check-input ml-2",
                            attrs: {
                              "true-value": "Y",
                              "false-value": "N",
                              type: "checkbox"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.data.row.tutorUseYn)
                                ? _vm._i(_vm.data.row.tutorUseYn, null) > -1
                                : _vm._q(_vm.data.row.tutorUseYn, "Y")
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.data.row.tutorUseYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : "N"
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.data.row,
                                        "tutorUseYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.data.row,
                                        "tutorUseYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.data.row, "tutorUseYn", $$c)
                                }
                              }
                            }
                          }),
                          _c(
                            "label",
                            { staticClass: "form-check-label ml-4" },
                            [_vm._v("강사사용")]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.data.row.studentUseYn,
                                expression: "data.row.studentUseYn"
                              }
                            ],
                            staticClass: "form-check-input ml-2",
                            attrs: {
                              "true-value": "Y",
                              "false-value": "N",
                              type: "checkbox"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.data.row.studentUseYn)
                                ? _vm._i(_vm.data.row.studentUseYn, null) > -1
                                : _vm._q(_vm.data.row.studentUseYn, "Y")
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.data.row.studentUseYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : "N"
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.data.row,
                                        "studentUseYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.data.row,
                                        "studentUseYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.data.row, "studentUseYn", $$c)
                                }
                              }
                            }
                          }),
                          _c(
                            "label",
                            { staticClass: "form-check-label ml-4" },
                            [_vm._v("학생사용")]
                          )
                        ])
                      ])
                    ])
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c("th", [_vm._v("키워드")]),
                _c(
                  "td",
                  { attrs: { colspan: "3" } },
                  [
                    _c("Keyword", {
                      key: _vm.keywords.text,
                      attrs: {
                        box: _vm.keywords.box,
                        boxText: _vm.keywords.text,
                        type: "key"
                      },
                      on: {
                        keywordChange: _vm.keywordChange,
                        keywordRemove: _vm.keywordRemove
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("tr", [
                _c("th", [_vm._v("태그")]),
                _c(
                  "td",
                  { attrs: { colspan: "3" } },
                  [
                    _c("Keyword", {
                      key: _vm.tags.text,
                      attrs: {
                        box: _vm.tags.box,
                        boxText: _vm.tags.text,
                        type: "tag"
                      },
                      on: {
                        keywordChange: _vm.keywordChange,
                        keywordRemove: _vm.keywordRemove
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]),
      _vm.popupType == "txt"
        ? _c("div", [
            _c(
              "div",
              { staticClass: "content-heading mt-1", attrs: { div: "" } },
              [_c("div", [_vm._v("매핑정보")])]
            ),
            _c("div", { staticClass: "card card-default" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("form", { attrs: { "data-vv-scope": "editMpp" } }, [
                  _c("table", { staticClass: "table table-bordered" }, [
                    _c("colgroup", [
                      _c("col", {
                        staticClass: "bg-lightdark",
                        attrs: { width: "15%" }
                      }),
                      _c("col", { attrs: { width: "35%" } }),
                      _c("col", {
                        staticClass: "bg-lightdark",
                        attrs: { width: "15%" }
                      }),
                      _c("col", { attrs: { width: "35%" } })
                    ]),
                    _c("tr", [
                      _c("th", [_vm._v("콘텐츠 용도")]),
                      _c(
                        "td",
                        [
                          _c("b-input-group", [
                            _c(
                              "div",
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.exterUrl
                                      ? _vm.purpTypeCd_exterUrl
                                      : _vm.purpTypeCd
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.exterUrl_addition1 =
                                        _vm.dataMpp.row.purpTypeCd == "209007"
                                      _vm.exterUrl_addition2 = false
                                      _vm.exterUrl_addition3 = false
                                      _vm.dataMpp.row.purpTypeCd_sub1 = undefined
                                      _vm.dataMpp.row.purpTypeCd_sub2 = undefined
                                      _vm.dataMpp.row.purpTypeCd_sub3 = undefined
                                      _vm.purpTypeCd_sub1_options = _vm.purpTypeCd_exterUrl_sub.filter(
                                        function(cd) {
                                          return (
                                            _vm.dataMpp.row.purpTypeCd &&
                                            cd.p_code.endsWith(
                                              _vm.dataMpp.row.purpTypeCd
                                            )
                                          )
                                        }
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.dataMpp.row.purpTypeCd,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataMpp.row,
                                        "purpTypeCd",
                                        $$v
                                      )
                                    },
                                    expression: "dataMpp.row.purpTypeCd"
                                  }
                                }),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.exterUrl &&
                                          _vm.exterUrl_addition1,
                                        expression:
                                          "exterUrl && exterUrl_addition1"
                                      }
                                    ],
                                    staticClass: "mt-1"
                                  },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        options: _vm.purpTypeCd_sub1_options
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.exterUrl_addition2 = true
                                          _vm.exterUrl_addition3 = false
                                          _vm.purpTypeCd_sub2 = undefined
                                          _vm.dataMpp.row.purpTypeCd_sub3 = undefined
                                          _vm.purpTypeCd_sub2_options = _vm.purpTypeCd_exterUrl_sub.filter(
                                            function(cd) {
                                              return (
                                                _vm.dataMpp.row
                                                  .purpTypeCd_sub1 &&
                                                cd.p_code.endsWith(
                                                  _vm.dataMpp.row
                                                    .purpTypeCd_sub1
                                                )
                                              )
                                            }
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.dataMpp.row.purpTypeCd_sub1,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataMpp.row,
                                            "purpTypeCd_sub1",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataMpp.row.purpTypeCd_sub1"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.exterUrl &&
                                          _vm.exterUrl_addition1 &&
                                          _vm.exterUrl_addition2,
                                        expression:
                                          "exterUrl && exterUrl_addition1 && exterUrl_addition2"
                                      }
                                    ],
                                    staticClass: "mt-1"
                                  },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        options: _vm.purpTypeCd_sub2_options
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.exterUrl_addition3 = true
                                          _vm.dataMpp.row.purpTypeCd_sub3 = undefined
                                          _vm.purpTypeCd_sub3_options = _vm.purpTypeCd_exterUrl_sub.filter(
                                            function(cd) {
                                              return (
                                                _vm.dataMpp.row
                                                  .purpTypeCd_sub2 &&
                                                cd.p_code.endsWith(
                                                  _vm.dataMpp.row
                                                    .purpTypeCd_sub2
                                                )
                                              )
                                            }
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.dataMpp.row.purpTypeCd_sub2,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataMpp.row,
                                            "purpTypeCd_sub2",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataMpp.row.purpTypeCd_sub2"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.exterUrl &&
                                          _vm.exterUrl_addition1 &&
                                          _vm.exterUrl_addition2 &&
                                          _vm.exterUrl_addition3,
                                        expression:
                                          "exterUrl && exterUrl_addition1 && exterUrl_addition2 && exterUrl_addition3"
                                      }
                                    ],
                                    staticClass: "mt-1"
                                  },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        options: _vm.purpTypeCd_sub3_options
                                      },
                                      model: {
                                        value: _vm.dataMpp.row.purpTypeCd_sub3,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataMpp.row,
                                            "purpTypeCd_sub3",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataMpp.row.purpTypeCd_sub3"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _c("th", [_vm._v("유료여부")]),
                      _c(
                        "td",
                        [
                          _c("b-input-group", [
                            _c("div", [
                              _c("div", { staticClass: "form-check mb-2" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.dataMpp.row.payYn,
                                      expression: "dataMpp.row.payYn"
                                    }
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: {
                                    id: "form-check-payYn",
                                    "true-value": "Y",
                                    "false-value": "N",
                                    type: "checkbox"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.dataMpp.row.payYn
                                    )
                                      ? _vm._i(_vm.dataMpp.row.payYn, null) > -1
                                      : _vm._q(_vm.dataMpp.row.payYn, "Y")
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.dataMpp.row.payYn,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? "Y" : "N"
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.dataMpp.row,
                                              "payYn",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.dataMpp.row,
                                              "payYn",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.dataMpp.row, "payYn", $$c)
                                      }
                                    }
                                  }
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label",
                                    attrs: { for: "form-check-payYn" }
                                  },
                                  [_vm._v("유료")]
                                )
                              ]),
                              _c("div", [
                                _vm._v(" ※ 체크하면 유료로 전환됩니다.")
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm.data.row.fileTypeCd == "211002"
                      ? _c("tr", [
                          _c("th", [_vm._v("동영상 재생구간")]),
                          _c(
                            "td",
                            [
                              _c("b-input-group", [
                                _c("span", { staticClass: "mt-1 mr-2" }, [
                                  _vm._v("시작")
                                ]),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.dataMpp.row.playStartTime,
                                      expression: "dataMpp.row.playStartTime"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "min_value:0",
                                      expression: "'min_value:0'"
                                    }
                                  ],
                                  class: {
                                    "form-control": true,
                                    "is-invalid": _vm.errors.has(
                                      "editMpp.playStartTime"
                                    )
                                  },
                                  attrs: {
                                    type: "text",
                                    name: "playStartTime",
                                    disabled: _vm.page.playAll
                                  },
                                  domProps: {
                                    value: _vm.dataMpp.row.playStartTime
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.dataMpp.row,
                                        "playStartTime",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("span", { staticClass: "mt-1 ml-2 mr-2" }, [
                                  _vm._v("~ 종료")
                                ]),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.dataMpp.row.playEndTime,
                                      expression: "dataMpp.row.playEndTime"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "min_value:0",
                                      expression: "'min_value:0'"
                                    }
                                  ],
                                  class: {
                                    "form-control": true,
                                    "is-invalid": _vm.errors.has(
                                      "editMpp.playEndTime"
                                    )
                                  },
                                  attrs: {
                                    type: "text",
                                    name: "playEndTime",
                                    disabled: _vm.page.playAll
                                  },
                                  domProps: {
                                    value: _vm.dataMpp.row.playEndTime
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.dataMpp.row,
                                        "playEndTime",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.page.playAll,
                                      expression: "page.playAll"
                                    }
                                  ],
                                  staticClass: "mt-2 ml-2",
                                  attrs: { type: "checkbox", id: "playAll" },
                                  domProps: {
                                    checked: Array.isArray(_vm.page.playAll)
                                      ? _vm._i(_vm.page.playAll, null) > -1
                                      : _vm.page.playAll
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$a = _vm.page.playAll,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.page,
                                                "playAll",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.page,
                                                "playAll",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(_vm.page, "playAll", $$c)
                                        }
                                      },
                                      function($event) {
                                        return _vm.playAllChanged()
                                      }
                                    ]
                                  }
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "mt-1 ml-1",
                                    attrs: { for: "playAll" }
                                  },
                                  [_vm._v("전체구간")]
                                )
                              ])
                            ],
                            1
                          ),
                          _c("th", { attrs: { colspan: "2" } }, [
                            _c("span", [
                              _vm._v(" ※ 일부구간만 재생 시 설정해주세요.")
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _c("tr", [
                      _c("th", [_vm._v("등록자/등록일")]),
                      _c("td", [
                        _c("input", {
                          class: { "form-control": true },
                          staticStyle: { width: "100%" },
                          attrs: { type: "text", name: "regId", readonly: "" },
                          domProps: {
                            value:
                              _vm.dataMpp.row.regId +
                              "(" +
                              _vm.dataMpp.row.regDt +
                              ")"
                          }
                        })
                      ]),
                      _c("th", [_vm._v("수정자/수정일")]),
                      _c("td", [
                        _c("input", {
                          class: { "form-control": true },
                          staticStyle: { width: "100%" },
                          attrs: { type: "text", name: "regDt", readonly: "" },
                          domProps: {
                            value:
                              _vm.dataMpp.row.updId +
                              "(" +
                              _vm.dataMpp.row.updDt +
                              ")"
                          }
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _c("div", { staticClass: "card-footer" }, [
                _c(
                  "div",
                  { staticClass: "card-tool float-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-xs btn-outline-info mr-2",
                        attrs: { variant: "outline-info mr-2" },
                        on: {
                          click: function($event) {
                            return _vm.close()
                          }
                        }
                      },
                      [_vm._v("목록")]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-xs btn-outline-danger mr-2",
                        attrs: { variant: "outline-info mr-2" },
                        on: {
                          click: function($event) {
                            return _vm.removeMpp()
                          }
                        }
                      },
                      [_vm._v("매핑삭제")]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-xs btn-outline-info mr-2",
                        attrs: { variant: "outline-info mr-2 px-3" },
                        on: {
                          click: function($event) {
                            return _vm.saveAll()
                          }
                        }
                      },
                      [_vm._v("저장")]
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        : _c("div", [
            _c(
              "div",
              { staticClass: "content-heading mt-1", attrs: { div: "" } },
              [
                _c("div", [
                  _vm._v("매핑목록(" + _vm._s(_vm.dataMppList.row.length) + ")")
                ])
              ]
            ),
            _c("div", { staticClass: "card card-default" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("form", { attrs: { "data-vv-scope": "editMppList" } }, [
                  _c(
                    "table",
                    {
                      staticClass:
                        "table table-striped table-bordered table-hover"
                    },
                    [
                      _c("colgroup", [
                        _c("col", { attrs: { width: "14%%" } }),
                        _c("col", { attrs: { width: "50%%" } }),
                        _c("col", { attrs: { width: "13%" } }),
                        _c("col", { attrs: { width: "13%" } }),
                        _c("col", { attrs: { width: "10%" } })
                      ]),
                      _c("thead", [
                        _c("tr", [
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v("매핑 ID")
                          ]),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v("매핑위치")
                          ]),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v("콘텐츠용도")
                          ]),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v("유료여부")
                          ]),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v("자세히보기")
                          ])
                        ])
                      ]),
                      _c(
                        "tbody",
                        [
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.dataMppList.row.length == 0,
                                  expression: "dataMppList.row.length==0"
                                }
                              ],
                              staticClass: "text-center"
                            },
                            [
                              _c("td", { attrs: { colspan: "5" } }, [
                                _vm._v("No matching records")
                              ])
                            ]
                          ),
                          _vm._l(_vm.dataMppList.row, function(item, index) {
                            return _c("tr", { key: index }, [
                              _c("td", [_vm._v(_vm._s(item.mappingSeq))]),
                              _c("td", [_vm._v(_vm._s(item.mapLocation))]),
                              _c("td", [_vm._v(_vm._s(item.purpTypeCd))]),
                              _c("td", [_vm._v(_vm._s(item.payYn))]),
                              _c("td", { staticClass: "text-center" }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        staticClass: "btn btn-sm btn-secondary",
                                        attrs: { variant: "outline-info mr-2" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.popupOpen(item, index)
                                          }
                                        }
                                      },
                                      [
                                        _c("em", {
                                          staticClass: "fa fa-search"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ])
                          })
                        ],
                        2
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.parentType == "file" || _vm._saveType == "ins",
              expression: "parentType=='file' || _saveType == 'ins'"
            }
          ],
          staticClass: "footer"
        },
        [
          _c(
            "div",
            { staticClass: "float-right" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn btn-b btn-outline-danger mr-2",
                  attrs: { variant: "outline-info mr-2" },
                  on: {
                    click: function($event) {
                      return _vm.insClose()
                    }
                  }
                },
                [_vm._v("취소")]
              ),
              _c(
                "b-button",
                {
                  staticClass: "btn btn-b btn-info mr-2",
                  attrs: { variant: "info mr-2" },
                  on: {
                    click: function($event) {
                      return _vm.updateDelete()
                    }
                  }
                },
                [_vm._v("삭제")]
              ),
              _c(
                "b-button",
                {
                  staticClass: "btn btn-b btn-info mr-2",
                  attrs: { variant: "info mr-2" },
                  on: {
                    click: function($event) {
                      return _vm.save()
                    }
                  }
                },
                [_vm._v("저장")]
              )
            ],
            1
          )
        ]
      ),
      _c("a", { staticStyle: { display: "none" }, attrs: { id: "fileDown" } }),
      _c("a", {
        staticStyle: { display: "none" },
        attrs: { id: "filePreview", target: "_blank" }
      }),
      _c(
        "b-modal",
        {
          attrs: {
            id: "fileModal",
            size: "xl",
            title: "교과서정보",
            "hide-footer": ""
          },
          model: {
            value: _vm.popupTextBookInfo,
            callback: function($$v) {
              _vm.popupTextBookInfo = $$v
            },
            expression: "popupTextBookInfo"
          }
        },
        [
          _c("CsTextBookPageInfo", {
            key: "atrbInfo.fileSeq",
            attrs: {
              fileSeq: _vm.AddfileSeq,
              orgContSeq: _vm.AddcontSeq,
              mppdata: _vm.dataMpp,
              parentType: "file"
            },
            on: { "modal-state": _vm.close }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }